import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  activeAdvertisementPlaylist,
  createAdvertisementPlaylist,
  deleteAdvertisementPlaylist,
  getAdvertisementPlaylist,
  inactiveAdvertisementPlaylist,
  listAdvertisementPlaylist,
  updateAdvertisementPlaylist,
} from 'api/setting/advertisement/advertisement-playlist.api';
import {
  ActiveAdvertisementPlaylistRequestModel,
  DeleteAdvertisementPlaylistRequestModel,
  GetAdvertisementPlaylistRequestModel,
  InactiveAdvertisementPlaylistRequestModel,
  ListAdvertisementPlaylistRequestModel,
  SaveAdvertisementPlaylistRequestModel,
} from 'models/setting/advertisement/advertisement-playlist.model';

export const getAdvertisementPlaylistAction = createAsyncThunk(
  'GET_ADVERTISEMENT_PLAYLIST_REQUEST',
  async (payload: GetAdvertisementPlaylistRequestModel) =>
    getAdvertisementPlaylist(payload),
);

export const listAdvertisementPlaylistAction = createAsyncThunk(
  'LIST_ADVERTISEMENT_PLAYLIST_REQUEST',
  async (payload: ListAdvertisementPlaylistRequestModel) =>
    listAdvertisementPlaylist(payload),
);

export const createAdvertisementPlaylistAction = createAsyncThunk(
  'CREATE_ADVERTISEMENT_PLAYLIST_REQUEST',
  async (
    payload: SaveAdvertisementPlaylistRequestModel,
    { rejectWithValue },
  ) => {
    try {
      return await createAdvertisementPlaylist(payload);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data);
    }
  },
);

export const updateAdvertisementPlaylistAction = createAsyncThunk(
  'UPDATE_ADVERTISEMENT_PLAYLIST_REQUEST',
  async (
    payload: SaveAdvertisementPlaylistRequestModel,
    { rejectWithValue },
  ) => {
    try {
      return await updateAdvertisementPlaylist(payload);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data);
    }
  },
);

export const deleteAdvertisementPlaylistAction = createAsyncThunk(
  'DELETE_ADVERTISEMENT_PLAYLIST_REQUEST',
  async (
    payload: DeleteAdvertisementPlaylistRequestModel,
    { rejectWithValue },
  ) => {
    try {
      return await deleteAdvertisementPlaylist(payload);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data);
    }
  },
);

export const inactiveAdvertisementPlaylistAction = createAsyncThunk(
  'INACTIVE_ADVERTISEMENT_PLAYLIST_REQUEST',
  async (
    payload: InactiveAdvertisementPlaylistRequestModel,
    { rejectWithValue },
  ) => {
    try {
      return await inactiveAdvertisementPlaylist(payload);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data);
    }
  },
);

export const activeAdvertisementPlaylistAction = createAsyncThunk(
  'ACTIVE_ADVERTISEMENT_PLAYLIST_REQUEST',
  async (
    payload: ActiveAdvertisementPlaylistRequestModel,
    { rejectWithValue },
  ) => {
    try {
      return await activeAdvertisementPlaylist(payload);
    } catch (err: any) {
      return rejectWithValue(err?.response?.data);
    }
  },
);
